import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';

// Pages
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Generate from './pages/Generate';
import History from './pages/History';
import Subscription from './pages/Subscription';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import Profile from './pages/Profile';
import OAuthCallback from './pages/OAuthCallback';
import AIAvatar from './pages/AIAvatar';
import SpeechSynthesis from './pages/SpeechSynthesis';
import Workspace from './pages/Workspace';
import AdCopy from './pages/AdCopy';
import EmailMarketing from './pages/EmailMarketing';
import BlogPosts from './pages/BlogPosts';
import ProductDescriptions from './pages/ProductDescriptions';
import ImageComposition from './pages/ImageComposition';
import ImageGeneration from './pages/ImageGeneration';
import PosterGeneration from './pages/PosterGeneration';
import MarketSurvey from './pages/MarketSurvey';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Blackboard from './pages/Blackboard';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Billing from './pages/Billing';
import ContactUs from './pages/ContactUs';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            {/* Main routes - Public access, auth checked on API calls */}
            <Route path="/" element={<Dashboard />} />
            <Route path="/ai-avatar" element={<AIAvatar />} />
            <Route path="/speech-synthesis" element={<SpeechSynthesis />} />
            <Route path="/ad-copy" element={<AdCopy />} />
            <Route path="/email-marketing" element={<EmailMarketing />} />
            <Route path="/blog-posts" element={<BlogPosts />} />
            <Route path="/product-descriptions" element={<ProductDescriptions />} />
            <Route path="/image-composition" element={<ImageComposition />} />
            <Route path="/image-generation" element={<ImageGeneration />} />
            <Route path="/poster" element={<PosterGeneration />} />
            <Route path="/market-survey" element={<MarketSurvey />} />
            <Route path="/generate" element={<Generate />} />
            <Route path="/history" element={<History />} />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/subscription/success" element={<PrivateRoute><SubscriptionSuccess /></PrivateRoute>} />
            <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/billing" element={<PrivateRoute><Billing /></PrivateRoute>} />
            <Route path="/blackboard" element={<Blackboard />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/workspace" element={<Workspace />} />
            <Route path="/contact" element={<ContactUs />} />

            {/* Auth routes */}
            <Route path="/landing" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/auth/callback" element={<OAuthCallback />} />

            {/* Legal routes */}
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />

            {/* Redirect all other routes to dashboard */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
